var DualBet = function() {

    var calculate_amounts = function(amount, odd1, odd2) {
        var amounts = [];
        amounts[0] = amount * odd2 / (odd1 + odd2);
        amounts[1] = amount * odd1 / (odd1 + odd2);
        return amounts;
    };

    var verify_and_compute = function() {
        var amount = $('#amount').val().replace('€', '');
        amount = Generic.parseNumericInput(amount);
        var odd1 = Generic.parseNumericInput($('#first_odd').val());
        var odd2 = Generic.parseNumericInput($('#second_odd').val());

        if (amount <= 0 || odd1 < 1 || odd2 < 1) {
            $('#ii__result').val('');
        } else {
            var amounts = calculate_amounts(amount, odd1, odd2);
            var total_odd = Math.min(amounts[0] * odd1 / amount, amounts[1] * odd2 / amount);
            $('#total_odd_res').val(total_odd.toFixed(2));
            $('#amount1_res').val(amounts[0].toFixed(2) + '€');
            $('#amount2_res').val(amounts[1].toFixed(2) + '€');
        }
        $('#dbform').addClass('was-validated');
    };
    return {
        init: function() {
            $('.ii__form_input').val('');
            $('#gform').removeClass('was-validated');

            $('.ii__form_input').on('keyup paste', function(){
                verify_and_compute();
            });
        }
    };
}();
